import { render, staticRenderFns } from "./searchHeader.vue?vue&type=template&id=e87639fa&scoped=true&"
import script from "./searchHeader.vue?vue&type=script&lang=js&"
export * from "./searchHeader.vue?vue&type=script&lang=js&"
import style0 from "./searchHeader.vue?vue&type=style&index=0&id=e87639fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87639fa",
  null
  
)

export default component.exports